import { useEffect } from 'react'

import { endsWith, filter, get } from 'lodash'

import window from 'common/window'
import { useLocation } from 'components/ReactRouterProvider/context'
import { ApiUser } from 'store/user/type-definitions'

const { userpilot } = window
const { identify, reload, clean } = userpilot ?? {}

export const useTrackUserPilotMovement = () => {
  const location = useLocation()

  useEffect(() => {
    reload?.()
  }, [location])
}

const login = ({
  user,
  referralScid,
  referralSource,
}: {
  user: ApiUser
  referralScid?: number
  referralSource?: string
}) => {
  if (user?.Id && !!identify) {
    const accountId = user?.HighSchool?.Id || 'offthestreet'
    const accountName = user?.HighSchool?.SchoolName || 'offthestreet'
    const staff = endsWith(user?.Email, '@scoir.com')
    const classYear = get(user, 'Profile.GraduationYear')
    const filteredRoles = filter(user?.Roles, (role) => role !== 'RoleReceiver')

    identify(user.Id, {
      id: user.Id,
      staff,
      userType: 'student',
      classYear,
      referralScid,
      referralSource,
      roles: filteredRoles.join(', '),
      created_at: user.ConfirmationDate,
      company: {
        //Account Fields
        id: accountId,
        name: accountName,
      },
    })
  }
}

export const logout = () => {
  clean?.()
}

const userPilotHelper = { login, logout }
export default userPilotHelper
